import script from "./BadgeTotalNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./BadgeTotalNotifications.vue?vue&type=script&setup=true&lang=js"

import "./BadgeTotalNotifications.vue?vue&type=style&index=0&id=17c5bfbe&lang=css"

const __exports__ = script;

export default __exports__